/**
 * 위치 기반 유틸리티 함수
 */

export enum WanderingStatus {
    SAFE = 'safe',           // 안심 (100m 이내)
    WANDERING = 'wandering', // 이탈 (100m 초과)
    UNKNOWN = 'unknown'      // 알 수 없음 (집주소 미등록 또는 위치 정보 없음)
}

/**
 * Haversine 공식을 사용한 두 좌표 간 거리 계산 (미터 단위)
 */
export function calculateDistance(
    lat1: number, 
    lon1: number, 
    lat2: number, 
    lon2: number
): number {
    const R = 6371e3; // 지구 반지름 (미터)
    const φ1 = lat1 * Math.PI / 180;
    const φ2 = lat2 * Math.PI / 180;
    const Δφ = (lat2 - lat1) * Math.PI / 180;
    const Δλ = (lon2 - lon1) * Math.PI / 180;

    const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
              Math.cos(φ1) * Math.cos(φ2) *
              Math.sin(Δλ/2) * Math.sin(Δλ/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

    return R * c; // 미터 단위
}

/**
 * 사용자의 배회 상태 판단
 */
export function determineWanderingStatus(
    currentLat?: number,
    currentLon?: number,
    homeLat?: number,
    homeLon?: number,
    threshold: number = 100 // 기본 100m
): { status: WanderingStatus; distance?: number } {
    if (!currentLat || !currentLon || !homeLat || !homeLon) {
        return { status: WanderingStatus.UNKNOWN }
    }
    
    const distance = calculateDistance(currentLat, currentLon, homeLat, homeLon)
    
    return {
        status: distance > threshold ? WanderingStatus.WANDERING : WanderingStatus.SAFE,
        distance: Math.round(distance)
    }
}
